export default __webpack_public_path__ + "static/media/shuttle.7488fc04.svg";